import BaseService from "../base";
import Validator from "../../../../vendor/framework/validator";

class AgreementService extends BaseService
{
    requestUrls = {
        url:'/running/agreement/list',
        save:'/running/agreement/save',
        detail:'/running/agreement/detail',
        delete:'/running/agreement/delete',
    }

    types = {
        1:'用户协议',
        2:'隐私政策',
        3:'操作手册',
        4:'公司版权信息',
    }

    appends = ['typeDup', 'contentDup', 'clientDup'];

    clients = ['员工端', '客户端'];

    getList(suc) {
        this.post(
            this.requestUrls.url,
            {},
            suc
        )
    }

    save(field, suc, err) {
        var keys = [];
        for(var k in this.types) {
            keys.push(k);
        }
        var validator = new Validator(),
            rules = [
                ['type', 'required|in:'+keys.join(','), '请选择类型'],
                ['content', 'required', '请填写内容']
            ];

        if (! validator.validate(rules, field)) {
            return err(validator.getError());
        }

        this.post(
            this.requestUrls.save,
            field,
            suc,
            err
        )
    }

    getDetail(id, suc) {
        this.post(
            this.requestUrls.detail,
            {id:id},
            suc
        )
    }

    delete(model, suc, err) {
        this.post(
            this.requestUrls.delete,
            {id:model.id},
            suc,
            err
        )
    }

    getTypeDupAttribute() {
        return this.types[this.attributes['type']];
    }

    getContentDupAttribute() {
        var content = this.app.delHtmlTag(this.attributes['content']);
        var length = content.length;
        if (! content && this.attributes['content']) {
            if (this.attributes['content'].match(/<img/)) {
                return '--图片内容--';
            }
        }
        return length > 20 ? (content.substr(0, 17) + '...') : content;
    }

    getClientDupAttribute() {
        return this.clients[this.attributes['client']];
    }
}

export default AgreementService;
